import { render } from "./backButtonWhite.vue?vue&type=template&id=5564e426&scoped=true"
import script from "./backButtonWhite.vue?vue&type=script&lang=js"
export * from "./backButtonWhite.vue?vue&type=script&lang=js"

import "./backButtonWhite.vue?vue&type=style&index=0&id=5564e426&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5564e426"]])

export default __exports__